import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";


export default function PerfilCorrienteEDP13() {
  const [corrienteEDP15, setCorrienteEDP15] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [corrienteEDP16, setCorrienteEDP16] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [corrienteEDP13, setCorrienteEDP13] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [corrienteEDP14, setCorrienteEDP14] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 42,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);
    populateCorrienteEDP15(data);
    populateCorrienteEDP16(data);
    populateCorrienteEDP13(data);
    populateCorrienteEDP14(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCorrienteEDP15(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 15"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCorrienteEDP15({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteEDP16(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 16"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCorrienteEDP16({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteEDP13(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 13"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCorrienteEDP13({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteEDP14(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 14"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCorrienteEDP14({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Corriente EDP 13 - 14 - 15 - 16"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Corriente EDP 15 --------------------------------------- */}
            <Chart.Line
              name="Corriente EDP 15"
              data={corrienteEDP15.value}
              yAxis={1}
            />
            {/** -------------------------------- Corriente EDP 16 --------------------------------------- */}
            <Chart.Line
              name="Corriente EDP 16"
              data={corrienteEDP16.value}
              yAxis={1}
            />
            {/** -------------------------------- Corriente EDP 13 --------------------------------------- */}
            <Chart.Line
              name="Corriente EDP 13"
              data={corrienteEDP13.value}
              yAxis={0}
            />
            {/** -------------------------------- Corriente EDP 14 --------------------------------------- */}
            <Chart.Line
              name="Corriente EDP 14"
              data={corrienteEDP14.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={corrienteEDP15.fecha} />

            <Chart.YAxis
              labelSuffix=" A"
              title="Corriente EDP 13 - 14, A"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=" A"
              title="Corriente EDP 15 - 16, A"
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
